// -----------------------------------------------------------------------------
export interface TimerDelegate {
  onTimer(id?: string): void;
}

// -----------------------------------------------------------------------------
export class Timer {
  // ---------------------------------------------------------------------------
  private _timerId: number|null = null;
  private _id: string|undefined;
  private _delegate: TimerDelegate;
  private readonly _autoReset: boolean;
  private _intervalInMS: number;

  // ---------------------------------------------------------------------------
  public static async wait(intervalInMS: number): Promise<void> {
    return new Promise(resolve => {
      setTimeout(resolve, intervalInMS);
    });
  }

  // ---------------------------------------------------------------------------
  constructor(delegate: TimerDelegate, id?: string, autoReset = false) {
    this._delegate = delegate;
    this._id = id;
    this._autoReset = autoReset;
  }

  public get id() {
    return this._id;
  };

  // ---------------------------------------------------------------------------
  public start(intervalInMS: number): void {
    this.stop();

    this._intervalInMS = intervalInMS;
    this._timerId = setTimeout(this.handleTimerEvent, intervalInMS) as any;
  }

  // ---------------------------------------------------------------------------
  public stop(): void {
    if (this._timerId == null) {
      return;
    }

    clearTimeout(this._timerId);
    this._timerId = null;
  }

  // ---------------------------------------------------------------------------
  private handleTimerEvent = () => {
    this._timerId = null;
    this._delegate.onTimer(this._id);

    if (this._autoReset) {
      this.start(this._intervalInMS);
    }
  }
};
